import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import routes from '../../../routes';
import { userSelectors } from '../../../store/modules/user';

const { Router } = routes;

const useRedirectToLogin = (editCard: string) => {
  const user = useSelector(userSelectors.selectUserProfile);

  useEffect(() => {
    if (editCard === 'true' && !user) {
      Router.pushRoute('login', { redirectUrl: Router.router?.asPath || '' });
    }
  }, [user?.userId]);
};

export default useRedirectToLogin;
